<p class="sr-only" role="status">
    {{ draft.excludedCount() }} documents excluded from this pack.
</p>
<details
    [open]="draft.draggingDocument()"
    class="rounded-lg border border-border p-3"
>
    <summary class="cursor-pointer text-body-md text-muted">
        {{ draft.excludedCount() }} documents excluded
    </summary>
    <div
        cdkDropList
        [id]="`${actionId()}-excluded-documents`"
        cdkDropListData=""
        [cdkDropListConnectedTo]="draft.documentListIds(actionId())"
        [cdkDropListDisabled]="disabled()"
        (cdkDropListDropped)="dropExcluded($event)"
        class="relative grid gap-2 pt-2"
        [style.min-height.px]="
            documentDrag.minHeight(`${actionId()}-excluded-documents`, 40)
        "
    >
        @for (document of draft.documents(); track document.documentId) {
            @if (!draft.selectedDocuments().has(document.documentId)) {
                <qpx-quippy-pack-document
                    [actionId]="actionId()"
                    [document]="document"
                    [busy]="disabled()"
                    (changed)="changed.emit()"
                    (moved)="moved.emit($event)"
                />
            }
        }
        @if (!draft.excludedCount()) {
            <p class="m-0 text-body-sm text-muted">
                Drop documents here to exclude them.
            </p>
        }
    </div>
</details>
